import { MfoTheme } from "../MfoTheme";
import logoUrl from "./assets/logo.svg?url";

export const mfoTheme: MfoTheme = {
  assets: { logoUrl, logoMdUrl: logoUrl },
  urls: {
    mfoSignatureAgreementUrl:
      "https://site-minio.boomzaim.ru/sait/docs/2025-11-20/soglasenie-asp_1763625438.pdf",
    mfoPrivacyPolicyUrl:
      "https://site-minio.boomzaim.ru/sait/docs/2025-11-07/politika-obrabotki-i-zashhity-personalnyx-dannyx_1762508164.pdf",
  },
};
